import * as React from "react";
import type { SVGProps } from "react";
const SvgWashingMachine = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17 2H7C5.35 2 4 3.35 4 5v14c0 1.65 1.35 3 3 3h10c1.65 0 3-1.35 3-3V5c0-1.65-1.35-3-3-3Zm1 17c0 .55-.45 1-1 1H7c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1h10c.55 0 1 .45 1 1v14ZM8.01 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1Zm4-1c0 .55-.45 1-1 1s-1-.45-1-1 .45-1 1-1 1 .45 1 1ZM16 5h-2c-.55 0-1 .45-1 1s.45 1 1 1h2c.55 0 1-.45 1-1s-.45-1-1-1Zm-4 4c2.72 0 4.94 2.2 4.99 4.91V14c0 2.76-2.28 5-5 5S7.05 16.8 7 14.09V14c0-2.76 2.28-5 5-5Zm2.92 4.34A2.992 2.992 0 0 0 12 11h-.01c-1.12 0-2.08.62-2.6 1.53 1.02-.13 2.04.06 3.05.57.84.42 1.65.49 2.48.24Zm-5.84 1.32C9.38 16 10.57 17 12 17h.01c1.12 0 2.08-.62 2.6-1.53-.2.03-.4.04-.6.04-.82 0-1.64-.2-2.45-.61-.84-.42-1.65-.49-2.48-.24Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgWashingMachine;
